import $http from '@vue-util/http';
import hostlinkOrDevMode from '@utils/hostlinkOrDevMode';
import {
  ALL_STAR_RATINGS, INITIAL_PAGE_LIMIT, SUBSEQUENT_PAGE_LIMIT,
} from '../constants/reviews';

/**
 * @param {ReviewsState} reviewsState
 * @returns {{ limit: number, offset: number }}
 */
const getOffsetAndLimit = (reviewsState) => ({
  limit: reviewsState.page === 1 ? INITIAL_PAGE_LIMIT : SUBSEQUENT_PAGE_LIMIT,
  offset:
    reviewsState.page === 1
      ? 0
      : (reviewsState.page - 2) * SUBSEQUENT_PAGE_LIMIT + INITIAL_PAGE_LIMIT,
});

/**
 * @param {{reviewsState: ReviewsState, isFrequentlyMentioned: boolean}} param0
 */
function buildReviewsGETData({ reviewsState, isFrequentlyMentioned }) {
  return {
    params: {
      // eslint-disable-next-line no-mixed-operators
      ...(isFrequentlyMentioned && { feature: reviewsState.selectedFrequentlyMentioned } || []),
      sort: reviewsState.sortBy,
      search: reviewsState.searchQuery || null,
      rating: reviewsState.starFiltering === ALL_STAR_RATINGS
        ? null
        : reviewsState.starFiltering,
      ...getOffsetAndLimit(reviewsState),
    },
  };
}

/**
 * @param {string} hostlink
 * @param {string} productId
 * @returns {string}
 */
const getBaseUrl = (hostlink, productId) => `${hostlinkOrDevMode(hostlink)}/xapi/digital/v1/product/${productId}/reviews`;

/**
 * @param {{hostlink: string, productId: string, reviewsState: ReviewsState, isFrequentlyMentioned: boolean}} obj
 * @return {Promise<ReviewsResponse>}
 */
export function reviewsGET({
  hostlink, productId, reviewsState, isFrequentlyMentioned,
}) {
  const url = getBaseUrl(hostlink, productId);
  const data = buildReviewsGETData({ reviewsState, isFrequentlyMentioned });
  return $http.get(url, data);
}

/**
 * @param {{hostlink: string, productId: string}} obj
 * @return {Promise<ReviewsPhotosResponse>}
 */
export function reviewsPhotosGET({ hostlink, productId }) {
  const url = getBaseUrl(hostlink, productId);
  const data = {
    params: {
      photosAndReviews: true,
    },
  };
  return $http.get(url, data);
}

/**
 * @param {{hostlink: string, productId: string}} obj
 * @return {Promise<ReviewsFrequentlyMentionedResponse>}
 */
export function reviewsFrequentlyMentionedGET({ hostlink, productId }) {
  const url = `${getBaseUrl(hostlink, productId)}/features`;
  const data = {
    params: {
      requestFeature: true,
    },
  };
  return $http.get(url, data);
}
